import { mediaQueryLarge, isMobileBreakpoint } from '@theme/utilities';

class AccordionCustom extends HTMLElement {
  get details() { return this.querySelector('details'); }
  get summary() { return this.details.querySelector('summary'); }

  get #singleMode() { return this.dataset.singleMode !== 'false'; }
  get #isInFooter() { return this.closest('.shopify-section-group-footer-group') !== null; }

  #controller = new AbortController();

  connectedCallback() {
    const { signal } = this.#controller;

    this.#applyRules();

    this.summary.addEventListener('click', this.#handleClick, { signal });
    this.details.addEventListener('toggle', this.#handleToggle, { signal });
    this.addEventListener('keydown', this.#handleEsc, { signal });
    mediaQueryLarge.addEventListener('change', this.#applyRules, { signal });
  }

  disconnectedCallback() { this.#controller.abort(); }

  #handleClick = (e) => {
    const isMobile = isMobileBreakpoint();
    if ((isMobile && this.dataset.disableOnMobile === 'true') ||
        (!isMobile && this.dataset.disableOnDesktop === 'true')) {
      e.preventDefault();
    }
  };

  // Обычный режим "только один открыт" — работает ВЕЗДЕ, КРОМЕ футера
  #handleToggle = () => {
    if (!this.details.open || !this.#singleMode || this.#isInFooter) return;

    const container = this.closest('section, .shopify-section') || document.body;
    container.querySelectorAll('accordion-custom').forEach(acc => {
      if (acc !== this && !acc.#isInFooter) {
        acc.details.open = false;
      }
    });
  };

  #handleEsc = (e) => {
    if (e.key === 'Escape' && this.dataset.closeWithEscape === 'true') {
      e.preventDefault();
      this.details.open = false;
      this.summary.focus();
    }
  };

  // Главная функция — именно то, что ты хотел
  #applyRules = () => {
    const isMobile = isMobileBreakpoint();

    if (this.#isInFooter) {
      // === СПЕЦИАЛЬНО ДЛЯ ФУТЕРА ===
      if (isMobile) {
        this.details.open = false;                      // мобильные — всё закрыто
      } else {
        this.details.open = true;                       // десктоп — ВСЕ открыты
      }
    } else {
      // === ВЕЗДЕ КРОМЕ ФУТЕРА — старое поведение по атрибутам ===
      const shouldOpen =
        (isMobile && this.hasAttribute('open-by-default-on-mobile')) ||
        (!isMobile && this.hasAttribute('open-by-default-on-desktop'));

      this.details.open = shouldOpen;
    }
  };
}

if (!customElements.get('accordion-custom')) {
  customElements.define('accordion-custom', AccordionCustom);
}